import { useEffect } from 'react'
import { useQuery } from '@apollo/client/react'

import {
  AttachmentInformationByEntityDocument,
  ManualAttachmentFileType,
} from '~/api/graphql/generated/types'

export const useImagingAttachments = (orderId: string | undefined) => {
  const { data, loading, error, refetch } = useQuery(
    AttachmentInformationByEntityDocument,
    {
      variables: {
        entityId: orderId || '',
        entityType: ManualAttachmentFileType.IdexxImaging,
      },
      skip: !orderId,
    },
  )

  // We do want to refetch to ensure that when switching orders, we get the latest attachments
  useEffect(() => {
    if (orderId) {
      refetch()
    }
  }, [orderId, refetch])

  const attachments = data?.attachmentInformationByEntity?.attachments || []

  return {
    attachments,
    loading,
    error,
    refetch,
  }
}
